import { styled } from '@mui/material';
import { Form } from 'formik';

export const FormStyled = styled(Form)(() => ({
  '& .MuiFormControl-root:nth-child(2)': {
    marginBottom: '8px',
  },
}));
